import { render, staticRenderFns } from "./UploadPayment.vue?vue&type=template&id=1d45c698&"
import script from "./UploadPayment.vue?vue&type=script&lang=js&"
export * from "./UploadPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports